import { createFileRoute, Link } from "@tanstack/react-router";
import {
	DashboardContent,
	DashboardHeaderSection,
	DashboardLayout,
} from "@/components/dashboard/DashboardLayout";
import { DashboardPageHeader } from "@/components/dashboard/DashboardPageHeader";
import { SupportPageContent } from "@/components/support/SupportPageContent";
import { useSession } from "@/hooks/auth-hooks";

export const Route = createFileRoute("/dashboard/support")({
	component: DashboardSupportPage,
});

function DashboardSupportPage() {
	const { user } = useSession();

	return (
		<DashboardLayout>
			<DashboardHeaderSection>
				<DashboardPageHeader
					title="Get support"
					description={
						<>
							Pick a channel below, or check the{" "}
							<Link
								to="/docs"
								className="text-primary transition-colors hover:text-primary/80"
							>
								help docs
							</Link>{" "}
							first.
						</>
					}
				/>
			</DashboardHeaderSection>
			<DashboardContent>
				<SupportPageContent
					defaultName={user?.name ?? ""}
					defaultEmail={user?.email ?? ""}
					showHeader={false}
				/>
			</DashboardContent>
		</DashboardLayout>
	);
}
